'use client';
import { Celebration } from '@/components/celebration';
import { useStepData } from '@/components/stepData';
import { RootState } from '@/redux/store';
import { Button, Stack, Typography } from '@mui/material';
import { success } from '@repo/onb-api';
import { COLORS, ResultScreen } from '@repo/ui';
import { deleteClientCookie, formatter } from '@repo/utils';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

export default function SuccessPayments({ stepdata: stepDataProp }: { stepdata?: success['variables'] }) {
  const stepData = useStepData(stepDataProp);
  const redirectInterval = useRef(0);
  const router = useRouter();
  const [redirectTimeout, setRedirectTimeout] = useState(10);
  const installmentPlanType = stepData?.installmentPlanType;
  const firstName = stepData?.firstName;
  const newCustomer = stepData?.newCustomer;
  const { internal, returnURLSuccess, policyProduct } = useSelector((state: RootState) => state.additionalData);

  useEffect(() => {
    if (!internal) {
      redirectInterval.current = window.setTimeout(() => {
        setRedirectTimeout((t) => t - 1);
      }, 1000);
      if (redirectTimeout <= 0) {
        clearTimeout(redirectInterval.current);
        deleteClientCookie(['orderToken', 'instanceId', 'integrationType', 'policyProduct', 'utmData', 'accessKey']);
        router.push(returnURLSuccess || '/');
      }
    }
  }, [internal, redirectTimeout]);
  return (
    <>
      <ResultScreen
        status="success"
        title={`¡Felicitaciones ${formatter(firstName, 'capitalize')}!`}
        description={
          installmentPlanType !== 'DEFERRED_PAYMENT'
            ? 'ya debitamos la primera cuota y te vamos a enviar el resumen a tu mail.'
            : undefined
        }
        actions={
          internal &&
          (newCustomer ? (
            <Button
              component={Link}
              href={`${process.env.NEXT_PUBLIC_CUSTOMER_ROUTE}retrieve_activation`}
              fullWidth
              variant="contained"
              id="button-account"
            >
              Activar mi cuenta
            </Button>
          ) : (
            <Button
              component={Link}
              href={process.env.NEXT_PUBLIC_CUSTOMER_ROUTE || ''}
              fullWidth
              variant="contained"
              id="button-account"
            >
              Ingresar al Portal de Cliente
            </Button>
          ))
        }
      >
        {!internal ? (
          <Typography variant="subtitle2" sx={{ mb: 2 }}>
            Te redirigiremos a la tienda para que finalices la compra en 00:
            {redirectTimeout >= 10 ? redirectTimeout : `0${redirectTimeout}`} segundos
          </Typography>
        ) : (
          <Stack sx={{ alignItems: 'center', gap: 1 }}>
            <Typography component="h2" variant="h2" sx={{ color: COLORS.text.main }}>
              Podés ver los detalles en el Portal de Cliente
            </Typography>
            {policyProduct === 'EFECTIVOC' && (
              <Typography variant="subtitle2">
                Recordatorio: Un asesor se va a poner en contacto para confirmar y transferir tu préstamo digital.
              </Typography>
            )}
          </Stack>
        )}
      </ResultScreen>
      <Celebration />
    </>
  );
}
